<div class="page-header">
  <app-page-title>
    <!-- TODO: trigger fetch not implemented -->
    <button type="button" class="btn btn-primary btn-sm" page-title-action disabled title="ยังไม่รองรับ">
      <i class="bi bi-arrow-repeat me-1"></i>
      เรียกข้อมูล
    </button>
  </app-page-title>
</div>

<div class="card shadow-sm border-0 mb-4">
  <div class="card-header py-3 bg-white">
    <form class="d-flex align-items-center justify-content-between gap-2 flex-wrap" (ngSubmit)="search()">
      <div class="d-flex align-items-center gap-2">
        <div class="input-group input-group-sm master-search-group">
          <input type="text" class="form-control" name="term"
                 placeholder="กรอกข้อมูลสำหรับค้นหา"
                 [ngModel]="term()"
                 (ngModelChange)="term.set($event)"/>
          <button class="btn btn-default" type="submit">
            <i class="bi bi-search"></i>
          </button>
        </div>
        <button type="button" class="btn btn-sm btn-default" (click)="reset()">ล้าง</button>
      </div>

      <div class="d-flex align-items-center gap-2">
        <select class="form-select form-select-sm filter-select"
                name="requestType"
                [ngModel]="requestType()"
                (ngModelChange)="requestType.set($event); search()">
          <option value="">- วิธีการดึงข้อมูล -</option>
          <option value="Auto">Auto</option>
          <option value="Manual">Manual</option>
        </select>

        <select class="form-select form-select-sm filter-select"
                name="requestStatus"
                [ngModel]="requestStatus()"
                (ngModelChange)="requestStatus.set($event); search()">
          <option value="">- สถานะการดึงข้อมูล -</option>
          <option value="200">200 : Ok</option>
          <option value="500">500 : Error</option>
        </select>
      </div>
    </form>
  </div>

  <div class="card-subheader px-3 py-2 border-bottom bg-white d-flex align-items-center gap-2">
    <span class="text-body-secondary small">Show</span>
    <app-pagesize-select size="sm" [value]="pageData().page.size"
                         (valueChange)="pageData().page.size = $event; search()"/>
    <span class="text-body-secondary small">entries</span>
  </div>

  <div class="card-body p-0">
    <div class="table-responsive">
      <table class="table caption-top table-hover mb-0">
        <thead class="bg-light">
          <tr>
            <th nowrap class="text-center" style="width: 36px;">
              <input type="checkbox" class="form-check-input table-checkbox"
                     [checked]="isAllSelected()"
                     (change)="toggleSelectAll()"/>
            </th>
            <th nowrap class="text-center">No.</th>
            <th nowrap>โทเค็น</th>
            <th nowrap>ผู้ใช้งานที่ร้องขอ</th>
            <th nowrap>วันเวลาที่ร้องขอ</th>
            <th nowrap>วันเวลาที่ตอบกลับ</th>
            <th nowrap class="text-center">จำนวนแถวที่ได้</th>
            <th nowrap>สถานะการดึงข้อมูล</th>
            <th nowrap>วิธีดึงข้อมูล</th>
          </tr>
        </thead>
        <tbody>
          @if (pageData()?.content?.length === 0) {
            <tr>
              <td colspan="9" class="text-center py-4 text-body-secondary">- ไม่มีข้อมูล -</td>
            </tr>
          } @else {
            @for (row of pageData()?.content; track row.id; let i = $index) {
              <tr>
                <td class="text-center">
                  <input type="checkbox" class="form-check-input table-checkbox"
                         [checked]="isItemSelected(row.id)"
                         (change)="toggleSelectItem(row.id!)"/>
                </td>
                <td class="text-center">{{ (pageData().page?.size * pageData().page?.number) + (i + 1) }}</td>
                <td>
                  <a role="button" class="text-decoration-none text-primary pointer fw-semibold"
                     (click)="openAppDetail(row.token)">
                    {{ row.token || '-' }}
                  </a>
                </td>
                <td nowrap>{{ row.userId ?? 'System' }}</td>
                <td nowrap>{{ row.timeRequest | thaidatetime }}</td>
                <td nowrap>{{ row.timeServiceResponse | thaidatetime }}</td>
                <td class="text-center">{{ row.numberOfRows ?? 0 }}</td>
                <td>
                  @if (row.requestStatus) {
                    <span class="http-badge"
                          [class.http-badge--success]="statusTone(row.requestStatus) === 'success'"
                          [class.http-badge--danger]="statusTone(row.requestStatus) === 'danger'"
                          [class.http-badge--secondary]="statusTone(row.requestStatus) === 'secondary'">
                      {{ statusText(row.requestStatus) }}
                    </span>
                  } @else {
                    <span class="text-muted">n/a</span>
                  }
                </td>
                <td>{{ row.requestType || 'n/a' }}</td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="card-footer bg-white d-flex justify-content-between align-items-center">
    <span class="text-body-secondary small">Total {{ pageData().page?.totalElements ?? 0 }} records</span>
    <ngb-pagination [collectionSize]="pageData().page.totalElements"
                    [page]="pageData().page.number + 1"
                    [pageSize]="pageData().page.size"
                    [maxSize]="5"
                    [rotate]="true"
                    [boundaryLinks]="true"
                    (pageChange)="search($event)">
    </ngb-pagination>
  </div>
</div>

<div class="alert alert-info alert-dismissible fade show mt-3" role="alert">
  <strong>หมายเหตุ</strong><br/>
  ข้อมูล Log จะถูกเก็บไว้นานสูงสุด 150 วัน
  <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
</div>
